import * as React from "react";
import * as locales from "../../../../locales.json";
import styled from "styled-components";
import { I18n } from "i18n-js";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import Button from "../../../reusable/button";
import InvoiceModal from "./invoiceModal";
import SubscriptionCreditCardModal from "./subscriptionCreditCardModal";
import { InvoicePaymentMethodPropTypes } from "../lib/types";
import {
  StyledParagraphBold,
  StyledLink,
  StyledHelperText,
} from "../lib/styles";
import { redesignTheme } from "../../../theme/theme";

const StyledInvoiceContainer = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
`;

const StyledButtonWrapper = styled.div`
  margin-top: ${redesignTheme.spacing[4.5]};
`;

const InvoicePaymentMethod = ({
  cardType,
  last4,
  fetchData,
  openPortal,
  paymentDueOn,
  paymentMethodOnFile,
  refillAmount,
  refillThreshold,
  setPageLoading,
  subscriptionId,
  type,
  updateToastMessage,
}: InvoicePaymentMethodPropTypes): React.ReactElement => {
  const [modal, setModal] = React.useState("");

  const closeModal = (): void => {
    return setModal("");
  };

  const helperText =
    type === "reward"
      ? i18n.translate(
          "admin_pages.settings.billing.learn_more_reward_invoices"
        )
      : i18n.translate(
          "admin_pages.settings.billing.learn_more_subscription_invoices"
        );

  return (
    <>
      <StyledInvoiceContainer data-testid="invoice-payment-method">
        <StyledParagraphBold>
          {i18n.translate("admin_pages.settings.billing.pay_by_invoice")}
        </StyledParagraphBold>
        <div style={{ marginTop: redesignTheme.spacing[3] }}>
          <StyledLink
            data-testid="learn-more-link"
            onClick={() => setModal("invoices")}
          >
            {i18n.translate(
              "admin_pages.settings.billing.important_information"
            )}{" "}
          </StyledLink>

          <StyledHelperText>{helperText}</StyledHelperText>
          {type === "subscription" && (
            <StyledButtonWrapper>
              <Button
                onClick={() => setModal("subscriptionCreditCard")}
                size="xs"
                testId="pay-by-credit-card"
                variant="secondaryInverse"
              >
                {i18n.translate(
                  "admin_pages.settings.billing.pay_by_credit_card"
                )}
              </Button>
            </StyledButtonWrapper>
          )}
        </div>
      </StyledInvoiceContainer>
      <InvoiceModal
        closeModal={closeModal}
        modal={modal}
        paymentDueOn={paymentDueOn}
        refillAmount={refillAmount}
        refillThreshold={refillThreshold}
        type={type}
      />
      <SubscriptionCreditCardModal
        cardType={cardType}
        closeModal={closeModal}
        fetchData={fetchData}
        last4={last4}
        modal={modal}
        openPortal={openPortal}
        paymentMethodOnFile={paymentMethodOnFile}
        setPageLoading={setPageLoading}
        subscriptionId={subscriptionId}
        updateToastMessage={updateToastMessage}
      />
    </>
  );
};

export default InvoicePaymentMethod;
